import styled from 'styled-components';
import { Radio as AntdRadio, GlobalToken } from 'antd';

import { getTableCss } from '@/comp/pages/EnginePage/Engine/Common/styled';

interface RangeContainerProps {
  type: string;
  $fromFallbackOverview?: boolean;
  theme: {
    token: GlobalToken;
  };
}

export const RangeContainer = styled.div<RangeContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  
  .flex-row {
    display: flex;
    align-items: center;
  }

  .flex-column {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .range-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    .range-label {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      text-transform: uppercase;
      color: ${({ theme: { token } }) => token.colorTextSecondary};
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    }

    .pressure-range-values {
      margin-right: ${({ theme: { token } }) => token.marginXL}px;
    }

    .range-values {
      display: flex;
      justify-content: center;
      align-items: baseline;
      background-color: ${({ theme: { token } }) => token.colorBgContainer};
      color: ${({ theme: { token } }) => token.colorText};
      border: 2px solid ${({ theme: { token } }) => token.colorBorderSecondary};
      border-radius: 20px;
      min-width: 150px;

      .range-bounds {
        font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      }

      .range-unit {
        margin-left: ${({ theme: { token } }) => token.marginXXS}px;
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        text-transform: uppercase;
      }
    }
  }

  .pressure-icon {
    margin-right: -1px;
    width: 35px;
    height: 35px;
  }

  .flow-icon {
    transform: rotate(90deg);
    width: 35px;
    height: 35px;
    margin-bottom: -1px;
  }

  .rule-container {
    display: flex;
    flex-direction: column;
    text-align: center;
    min-width: 370px;
    margin-top: ${({ $fromFallbackOverview, theme: { token } }: RangeContainerProps) =>
      $fromFallbackOverview ? '0' : `${token.margin}px`};

    .rule-name {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: ${({ theme: { token } }) => token.colorBorderSecondary};
      position: sticky;
      top: 0;
      z-index: 3;
      ${({ $fromFallbackOverview }: RangeContainerProps) =>
        $fromFallbackOverview &&
        `
        position: relative;
        justify-content: flex-end;
      `}
    }

    .table-container {
      display: flex;
      flex-direction: column;
    }

    .rule-label {
      width: 100%;
      color: ${({ theme: { token } }) => token.colorText};
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
            font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      ${({ $fromFallbackOverview }: RangeContainerProps) =>
        $fromFallbackOverview &&
        `
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
        top: 2px;
      `}

      .ant-input { 
        background-color: ${({ theme: { token } }) => token.colorBorderSecondary};
        border: none;
        color: ${({ theme: { token } }) => token.colorPrimary};
        text-align: center;
        font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
      }
    }

  ${({ theme: { token } }) => getTableCss(token)}

  .table {
    margin-bottom: 0 !important;

    .ant-table {
      background-color: ${({ theme: { token } }) => token.colorBgContainer};

      .ant-table-thead > tr > th:not(:first-child) {
        background-color: ${({ theme: { token } }) => token.colorBgContainer};
      }

      .ant-table-cell {
        text-align: center;
      }

      .ant-table-thead > tr > th:first-child,
      td:first-child {
        background-color: ${({ theme: { token } }) => token.colorBgElevated};    
      }

      .ant-table-tbody > tr > td.ant-table-cell-row-hover {
        background-color: ${({ theme: { token } }) => token.colorBgContainer};
      }

      .ant-table-tbody > tr > td.ant-table-cell-row-hover:first-child {
        background-color: ${({ theme: { token } }) => token.colorBgElevated};
      }

      .ant-table-tbody > tr:last-child > td {
        border-bottom: none !important;
      }

      .ant-input { 
        border: none;
        color: ${({ theme: { token } }) => token.colorPrimary};
        text-align: center;
        height: 18px;
      }
    }

    .table-cell {
      color: ${({ theme: { token } }) => token.colorTextTertiary};
      height: 24px;
    }

    .check-icon {
      width: 10px;
      color: ${({ theme: { token } }) => token.colorBorder};
    }

    .view-mode-modulate-checkbox {
      &.ant-checkbox-wrapper-disabled {
        cursor: default;
      }

      .ant-checkbox.ant-checkbox-checked .ant-checkbox-inner {
        border: none;
        background-color: transparent;
        outline: ${({ theme: { token } }) => token.colorBorder} solid 2px;
      }

      .ant-checkbox.ant-checkbox-checked .ant-checkbox-inner::after {
        border-color: ${({ theme: { token } }) => token.colorBorder};
      }

      .ant-checkbox:not(.ant-checkbox-checked) .ant-checkbox-inner {
        border: none;
        background-color: transparent;
      }
    }

    .modulate-checkbox-container {
      width: 25px;
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
      padding-bottom: ${({ theme: { token } }) => token.paddingXXS}px;
      margin: 0 auto;
    }

    

    .edit-mode-modulate-checkbox {
      .ant-checkbox:not(.ant-checkbox-checked) .ant-checkbox-inner {
        border: 1.5px solid ${({ theme: { token } }) => token.colorPrimary};
        background-color: transparent;
      }
    }

    .edited {
      &.ant-input { 
        background-color: ${({ theme: { token } }) => token.colorBgElevated};
        height: 22px;
      }
    }

    .validation-error-indicator {
      position: absolute;
      top: 10px;
      left: 5px;
      right: 5px;
      bottom: 10px;
      border: 2px solid ${({ theme: { token } }) => token.colorError};
      background-color: transparent;
      border-radius: 4px;
      pointer-events: none;
      z-index: 1;
    }
  }
`;

interface RadioProps {
  $isViewMode?: boolean;
  theme: {
    token: GlobalToken;
  };
}

export const Radio = styled(AntdRadio)<RadioProps>`
  &.ant-radio-wrapper {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ theme: { token } }) => token.colorTextTertiary};

    .ant-radio-inner {
      width: 20px;
      height: 20px;
      background-color: ${({ theme: { token } }) => token.colorBgContainer};
      border: 2px solid ${({ theme: { token } }) => token.colorTextSecondary};

      ::after {
        width: 28px;
        height: 28px;
        margin-block-start: -${({ theme: { token } }) => token.margin}px;
        margin-inline-start: -${({ theme: { token } }) => token.margin}px;
        background-color: ${({ $isViewMode, theme: { token } }) =>
          $isViewMode ? token.colorBorder : token.colorPrimary};
      }
    }

    &.disabled {
      opacity: 50%;

      .ant-radio-inner {
        opacity: 30%;
      }
    }

    .ant-radio-checked {
      .ant-radio-inner {
        border: 2px solid
          ${({ $isViewMode, theme: { token } }) => ($isViewMode ? token.colorBorder : token.colorPrimary)};
      }
    }
  }
`;

interface TooltipUlProps {
  theme: {
    token: GlobalToken;
  };
}

export const TooltipUl = styled.ul<TooltipUlProps>`
  li:not(:first-child) {
    margin-top: ${({ theme: { token } }) => token.marginXS}px;
  }
`;

interface UnderlineCellContainerProps {
  $hasOnChange?: boolean;
  $color?: string;
  $accentColor?: string;
  $centerAlign?: boolean;
  theme: {
    token: GlobalToken;
  };
}

export const UnderlineCellContainer = styled.div<UnderlineCellContainerProps>`
  display: flex;
  justify-content: ${({ $centerAlign }) => ($centerAlign ? 'center' : 'left')};
  align-items: center;
  height: 24px;

  .empty-value {
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    text-align: center;
    padding: ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.paddingXS}px;
  }

  .editable-span {
    border-bottom: 1px solid ${({ theme: { token } }) => token.colorPrimary};
    text-align: center;
    outline: none;
    color: ${({ theme: { token } }) => token.colorPrimary};
    cursor: ${({ $hasOnChange }) => ($hasOnChange ? 'text' : 'default')};
    min-width: 20px;
    padding: ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.paddingXS}px;
  }

  .disabled-value-span {
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    padding: ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.paddingXS}px;
  }

  .value-span {
    color: ${({ $color, theme: { token } }) => $color || token.colorText};
    padding: ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.paddingXS}px;
  }

  .modulate-checkbox {
    accent-color: ${({ $accentColor, theme: { token } }) => $accentColor || token.colorPrimary};
    transform: scale(1.2);
  }

  .draft-modulate-checkbox {
    accent-color: ${({ theme: { token } }) => token.colorPrimary};
    transform: scale(1.2);
  }
`;

export const BandConfigurationContainer = styled.div`
  width: 100%;
  pointer-events: auto;
`;
